// extracted by mini-css-extract-plugin
export default {"signup-form":"Signup_signup-form__hwSWF","error":"Signup_error__sHOwt"};